module.exports = __webpack_public_path__ + "img/744.49ab542f.jpg";